import { useContext } from "react";
import { AppContext } from "./components/AppContext";

export default function ColorPreviewer() {
	const { config, setIsEditing } = useContext(AppContext);

	return (
		<div className="flexer absolute right-2 top-0 z-[99] h-full ">
			<div
				className="flexer  cursor-pointer flex-col gap-3 rounded-2xl bg-white p-2 transition-all hover:shadow-xl dark:bg-dark-900"
				onClick={() => setIsEditing(true)}
			>
				{config.map((c, k) => {
					const { colors } = c;
					return (
						<div key={k} className="flex gap-2">
							{colors.map((z, w) => {
								const cl = w === 0 ? "" : "-ml-4";
								return (
									<div
										key={w}
										style={{ backgroundColor: z }}
										className={
											cl +
											" h-6 w-6 rounded-full border-2 border-white dark:border-dark-900"
										}
									></div>
								);
							})}
						</div>
					);
				})}
			</div>
		</div>
	);
}
